import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy /account/usage → /account/user/billing?tab=usage (same as :3100).
 */
export const Route = createFileRoute("/_authenticated/account/usage")({
  beforeLoad: () => {
    throw redirect({ to: "/account/user/billing", search: { tab: "usage" } });
  },
});
